import React from 'react'
import Image from 'next/image'
import {
  Stack,
  Text,
  VStack,
  Box,
  Container,
  Link,
} from '@chakra-ui/react'

import { AS_SEEN_ON } from './constants'
import * as styles from './styles'

function AsSeenOn() {
  return (
    <Container as="section" sx={styles.sectionContainer}>
      <VStack sx={styles.mainVStack}>
        <Text as="h1" sx={styles.headingText}>
          PDPA Pro ในสื่อต่างๆ
        </Text>
        <Stack sx={styles.logoStack}>
          {AS_SEEN_ON.map((data) => {
            return (
              <Link
                key={data.href}
                isExternal
                href={data.href}
                sx={styles.logoLink}
              >
                <Box sx={styles.imageContainer}>
                  <Image
                    src={data.image}
                    alt={data.alt}
                    layout="fill"
                    objectFit="contain"
                  />
                </Box>
              </Link>
            )
          })}
        </Stack>
      </VStack>
    </Container>
  )
}

export default AsSeenOn
